import React, { useState, useEffect, Fragment } from "react";
import { useLocation, useParams } from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useGetSearchQueryQuery } from "../../services/search";
import Loader from "../../Components/Loader";
import Button from "@mui/joy/Button";
import { useMediaQuery } from "react-responsive";
import SearchLoader from "../../Components/SearchLoader";
import { useGetUserDataQuery } from "../../services/login";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { notification } from "antd";
import "antd/dist/antd.min.css";
import { Helmet } from "react-helmet";
import Host from "../../Components/Host";
import ApisSearchResults from "./ApisSearchResults";
import { io } from "socket.io-client";

import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
const Root = styled("div")(({ theme }) => ({
  width: "100%",
  ...theme.typography.body2,
  color: (theme.vars || theme).palette.text.secondary,
  "& > :not(style) ~ :not(style)": {
    marginTop: theme.spacing(2),
  },
}));

function SearchPage() {
  const { userId, userToken, userEmail, languageCode, countryCode, cartToken } = useSelector((state) => state.auth);
  const location = useLocation();
  const { t } = useTranslation();
  const { query } = useParams();
  const limit = new URLSearchParams(location.search).get("size") || 48;
  const searchCountry = new URLSearchParams(location.search).get("country") || null;
  const thisCountry = searchCountry ? `&search_country=${searchCountry}` : "";
  const isMobcreen2 = useMediaQuery({ query: "(min-width: 0px) and (max-width: 992px)" });
  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );
  const [getProducts, setProductsData] = useState([]);
  const [getPage, setPage] = useState(1);
  const [getSearchId, setSearchId] = useState(0);
  const [socketId, setSocketId] = useState("");
  const {
    data: newPosts = [],
    isLoading,
    error,
    isError,
    isFetching,
    originalArgs,
  } = useGetSearchQueryQuery(
    {
      page: getPage,
      size: limit,
      query: query,
      search_id: `&search_id=${getSearchId}`,
      countryCode: countryCode,
      searchCountry: thisCountry,
      socketId: socketId,
      cartToken: cartToken,
    },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );
  const products = newPosts?.results;

  React.useEffect(() => {
    if (products?.length > 0) {
      setProductsData((prevPosts) => [...prevPosts, ...products]);
    }
  }, [newPosts]);

  useEffect(() => {
    if (products) {
      setProductsData(() => [...products]);
      setPage(1);
    }
  }, [query, searchCountry]);

  useEffect(() => {
    if (Number(getPage) === 1 && products) {
      setProductsData((prevPosts) => [...products]);
    }
  }, [getPage, products]);

  useEffect(() => {
    if (Number(getPage) === 1 && isFetching) {
      setProductsData((prevPosts) => []);
    }
  }, [getPage, query, searchCountry]);

  const lastId = getProducts?.slice(-1)[0]?.id || 0;

  const loadMore = () => {
    setPage((prevPage) => prevPage + 1);
    setSearchId(lastId);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  function loadFetch() {
    if (isLoading) {
      return true;
    } else if (isFetching) {
      return true;
    } else {
      return false;
    }
  }

  const [api, contextHolder] = notification.useNotification();
  React.useEffect(() => {
    if (error?.originalStatus === 429) {
      api["error"]({
        message: error?.data,
        showProgress: true,
        pauseOnHover: false,
        duration: 5,
        placement: "top",
      });
    }
  }, [error]);

  const [productUpdates, setProductUpdates] = useState([]);

  const API_URL_NEW =
    window.location.hostname === "en-dxb.thwifty.com"
      ? "https://api-ae.amazinge.store"
      : process.env.REACT_APP_API_CONNECT;

  useEffect(() => {
    if (!cartToken) return;

    const socket = io(API_URL_NEW, {
      transports: ["websocket"],
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 500,
    });

    socket.on("connect", () => {
      console.log("Connected:", socket.id);
      setSocketId(socket.id);

      socket.emit("join-cart", cartToken);
    });

    socket.on("joined-room", (room) => {
      console.log(":", room);
    });

    socket.on("cartUpdate", (data) => {
      console.log("update:");
      setProductUpdates((prev) => [...prev, data?.data]);
    });

    socket.on("disconnect", () => {
      console.warn("Disconnected");
    });

    socket.on("connect_error", (err) => {
      console.error("Error:", err.message);
    });

    return () => {
      socket.off("cartUpdate");
      socket.disconnect();
    };
  }, [cartToken]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{`${query ? query : ""} ${query && "|"} ${Host?.metaTitle}`}</title>
      </Helmet>
      {contextHolder}
      <div className="sp-style">
        <div className="search-section" style={{ position: "relative" }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12 mob-w100 mob-p0" style={{ padding: "5px" }}>
                <div className="row">
                  <div style={{ width: "100%", padding: "0px 0px 10px 0px" }}>
                    <div className="search-cardTitle" style={{ textAlign: "start" }}>
                      <div className="search-result-secton">
                        <div className="sp-query" style={{ width: "100%" }}>
                          <span style={{ display: "flex", alignItems: "center" }}>
                            <Root>
                              <Divider className="border-divider">
                                {isLoading ? (
                                  <span
                                    style={{
                                      fontSize: "0.95rem",
                                      fontWeight: 500,
                                      color: "#2f122e",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    Searching for&nbsp;{query}&nbsp;{" "}
                                    <span>
                                      <SearchLoader />
                                    </span>
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      fontSize: "0.95rem",
                                      fontWeight: 500,
                                      color: "#2f122e",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {loadFetch() ? (
                                      <>
                                        {" "}
                                        Searching for&nbsp;{query}&nbsp;{" "}
                                        <span>
                                          <SearchLoader />
                                        </span>
                                      </>
                                    ) : (
                                      <> Search results for&nbsp;{query}</>
                                    )}
                                  </span>
                                )}
                              </Divider>
                            </Root>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {loadFetch() ? (
                    ""
                  ) : (
                    <>
                      {newPosts?.length === 0 && (
                        <div className="no-result-found-secton">
                          <ErrorOutlineOutlinedIcon style={{ color: "#721c24" }} />
                          <div style={{ border: "none", background: "#fff0" }} className="cardTitle alert alert-danger">
                            Looks like we couldn't find what you're searching for.
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  <ApisSearchResults
                    getProducts={getProducts}
                    userData={userData}
                    isFetching={isFetching}
                    productUpdates={productUpdates}
                    loadFetch={loadFetch()}
                  />
                </div>
                <br />
              </div>

              {getProducts?.length > 0 && (
                <div
                  className="search-paginattion"
                  style={{ width: "100%", display: "flex", justifyContent: "center" }}
                >
                  <div style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                    <Button
                      style={{
                        border: "0.5px solid #39414a",
                        color: "#39414a",
                        fontWeight: 400,
                        height: "40px",
                        margin: "0px 10px",
                      }}
                      disabled={isFetching}
                      variant="outlined"
                      onClick={loadMore}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span>{loadFetch() ? "Loading" : t("load_more")}</span>
                        {loadFetch() && (
                          <span style={{ margin: "0px 10px" }}>
                            <Loader />
                          </span>
                        )}
                      </div>
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    </>
  );
}

export default SearchPage;
